<template>
  <v-row class="mb-auto" justify="center" id="hgzprint">
    <v-col cols="12" v-if="strHtml">
      <v-card class="pa-3" v-html="strHtml"></v-card>
    </v-col>
    <v-col cols="12">
      <search v-if="issearch" :items="headers" @querydata="querydata"></search>
      <v-data-table
        show-select
        @toggle-select-all="selectAll"
        :multi-sort="false"
        v-model="selected"
        item-key="Id"
        :headers="headers"
        :items="mainData"
        :items-per-page="limit"
        :options.sync="options"
        :server-items-length="countData"
        :loading="loading"
        class="elevation-1 text-no-wrap"
        show-group-by
        :footer-props="{
          itemsPerPageText: '分页:',
          'items-per-page-options': [10, 20, 30, 50, 100, -1],
        }"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>合格证</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-btn
              small
              :color="issearch ? 'error' : 'success'"
              dark
              class="mr-2"
              @click="issearch = !issearch"
            >
              <v-icon>{{
                issearch ? "mdi-magnify-close" : "mdi-magnify"
              }}</v-icon>
            </v-btn>
            <v-btn small color="warning" dark @click="delselect">
              删除 <v-icon>mdi-checkbox-marked-outline</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog1" max-width="600px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  class="mx-2"
                  color="info"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  >激活</v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">自助激活</span>
                </v-card-title>
                <v-card-text>
                  <v-form ref="form">
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-autocomplete
                          :items="lists1"
                          :rules="[(v) => !!v || '必填项']"
                          item-text="PiCi"
                          item-value="Id"
                          v-model="editedItem.PiCier.Id"
                          label="批次"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-menu
                          v-model="datepop1"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :rules="[(v) => !!v || '必填项']"
                              v-model="editedItem.DateAt"
                              label="开具日期"
                              prepend-icon="mdi-calendar"
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            locale="zh-cn"
                            v-model="editedItem.DateAt"
                            @input="datepop1 = false"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          :rules="[
                            (v) => !!v || '必填项',
                            (v) => /^\d+$/.test(v) || '必须为正整数',
                          ]"
                          v-model.number="editedItem.ProductNums"
                          label="产品数量"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          :rules="[(v) => !!v || '必填项']"
                          v-model.trim="editedItem.ProductUnit"
                          label="单位"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          :rules="[(v) => !!v || '必填项']"
                          v-model.trim="editedItem.StartCode"
                          label="起始流水码"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          :rules="[(v) => !!v || '必填项']"
                          v-model.trim="editedItem.EndCode"
                          label="结束流水码"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">取消</v-btn>
                  <v-btn
                    color="blue darken-1"
                    :loading="loading"
                    text
                    @click="active"
                    >保存 & 激活</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialog" max-width="600px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn small color="primary" dark v-bind="attrs" v-on="on"
                  >新增</v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container class="ma-0 pa-0">
                    <v-form ref="form">
                      <v-row>
                        <v-col cols="12" class="py-1">
                          <v-autocomplete
                            :items="lists1"
                            :rules="[(v) => !!v || '必填项']"
                            item-text="PiCi"
                            item-value="Id"
                            v-model="editedItem.PiCier.Id"
                            label="批次"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-1">
                          <v-text-field
                            :rules="[
                              (v) => !!v || '必填项',
                              (v) => /^\d+$/.test(v) || '必须为正整数',
                            ]"
                            v-model.number="editedItem.ProductNums"
                            label="产品数量"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-1">
                          <v-text-field
                            :rules="[(v) => !!v || '必填项']"
                            v-model.trim="editedItem.ProductUnit"
                            label="单位"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-1">
                          <v-text-field
                            :rules="[
                              (v) => !!v || '必填项',
                              (v) => /^\d+$/.test(v) || '必须为正整数',
                            ]"
                            v-model.number="editedItem.PrintNums"
                            label="打印份数"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-1">
                          <v-menu
                            v-model="datepop1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                :rules="[(v) => !!v || '必填项']"
                                v-model="editedItem.DateAt"
                                label="开具日期"
                                prepend-icon="mdi-calendar"
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              locale="zh-cn"
                              v-model="editedItem.DateAt"
                              @input="datepop1 = false"
                            >
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <!-- 新增：检测类型选择框 -->
                        <v-col cols="12" sm="6" class="py-1">
                          <v-checkbox
                            v-model="detectionType.self"
                            label="自行检测合格"
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-1">
                          <v-checkbox
                            v-model="detectionType.entrust"
                            label="委托检测合格"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-form>
                    <v-row v-if="!$vuetify.breakpoint.xsOnly">
                      <v-col class="py-0">
                        <span>样式预览：</span>
                        <v-card
                          class="mx-auto pa-3 ma-0"
                          max-width="450"
                          outlined
                        >
                          <LabelPrint
                            :certificate-list="fixedCertificateList"
                            :detection-type="detectionType"
                            @print-preview-closed="onPrintFinished"
                            ref="labelPrintRef"
                          />
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">取消</v-btn>
                  <v-btn
                    color="blue darken-1"
                    :loading="loading"
                    :disable="!loading"
                    text
                    @click="save"
                    >保存 & 打印</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.Status="{ item }">
          <v-icon :color="item.Status ? 'success' : 'text'">{{
            item.Status ? "mdi-checkbox-marked" : "mdi-checkbox-blank-outline"
          }}</v-icon>
        </template>
        <template v-solt:footer.page-text="{ item }">
          <v-btn color="success">text</v-btn>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon color="error" @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">刷新数据</v-btn>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import search from "@/components/search";
import LabelPrint from "@/components/labelPrint";

export default {
  components: {
    search,
    LabelPrint,
  },
  data: function () {
    return {
      fixedCertificateList: [
        {
          id: 1,
          productName: "",
          spec: "",
          address: this.$store.state.userInfo.Usersproer.Addr,
          producer: this.$store.state.userInfo.Usersproer.Name,
          phone: this.$store.state.userInfo.Usersproer.Phone,
          date: "",
        },
      ],
      dialog1: false,
      dialog: false,
      selected: [],
      headers: [
        {
          text: "产品",
          value: "PiCier.Producter.Name",
        },
        {
          text: "批次",
          value: "PiCier.PiCi",
        },
        {
          text: "数量",
          value: "ProductNums",
          groupable: false,
        },
        {
          text: "单位",
          value: "ProductUnit",
          groupable: false,
        },
        {
          text: "份数",
          value: "PrintNums",
          groupable: false,
        },
        {
          text: "开具日期",
          value: "DateAt",
        },
        {
          text: "激活",
          value: "Status",
        },
        // { text: "创建时间", value: "CreateAt", groupable: false },
        // { text: "更新时间", value: "UpdateAt", groupable: false },
        {
          text: "操作",
          value: "actions",
          sortable: false,
          groupable: false,
        },
      ],
      issearch: false,
      mainData: [],
      countData: 0,
      offset: 0,
      limit: this.$store.state.glimit,
      query: "",
      exclude: "",
      sortby: "",
      order: "",
      options: {},
      loading: false,
      printWindowHandle: null,
      editedIndex: -1,
      detectionType: { self: true, entrust: false },
      editedItem: {
        PiCier: {
          Id: 0,
        },
        DateAt: this.$utils.formatDate(new Date(), "yyyy-MM-dd"),
      },
      defaultItem: {
        PiCier: {
          Id: 0,
        },
        DateAt: this.$utils.formatDate(new Date(), "yyyy-MM-dd"),
      },
      lists1: [],
      datepop1: false,
      strHtml: "",
      jsLoadStatus: "",
      LodopObject: null,
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "新增" : "编辑";
    },
    hgzproduct() {
      let pcobj = this.lists1.filter((v) => v.Id == this.editedItem.PiCier.Id);
      if (pcobj.length > 0) {
        return pcobj[0].PiCi.split(" ")[0];
      } else {
        return "";
      }
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    options: {
      handler() {
        //立即执行
        this.limit = this.options.itemsPerPage;
        this.offset = (this.options.page - 1) * this.limit;
        this.sortby = "";
        this.order = "";
        for (let index = 0; index < this.options.sortBy.length; index++) {
          this.sortby += this.options.sortBy[index] + ",";
          this.order += this.options.sortDesc[index] ? "desc," : "asc,";
        }
        if (this.sortby.length > 0) {
          this.sortby = this.sortby.slice(0, -1);
          this.order = this.order.slice(0, -1);
        } else {
          this.sortby = "Status,Id";
          this.order = "asc,desc";
        }
        this.initialize();
      },
      deep: true, //对象深度监听
    },
  },
  mounted() {
    if (
      !this.$store.state.userInfo.Usersproer.Addr ||
      !this.$store.state.userInfo.Usersproer.Phone
    ) {
      this.$store.commit("setsnack", {
        message: "请填写地址和电话！",
        color: "warning",
        timeout: "-1",
      });
      this.$router.push("/myinfo");
    }
  },
  methods: {
    querydata(query, exclude) {
      this.query = query;
      this.exclude = exclude;
      this.initialize();
    },
    selectAll(item) {
      this.selected = item.value ? item.items : [];
    },
    delselect(e) {
      if (!confirm("确认删除所有选中项吗?")) return;
      if (this.selected.length > 0) {
        let ids = "";
        let arrid = [];
        for (let index = 0; index < this.selected.length; index++) {
          ids += this.selected[index].Id + ",";
          arrid.push(this.selected[index].Id);
        }
        if (ids.length > 0) {
          ids = ids.slice(0, -1);
        }
        this.loading = true;
        this.$api
          .delMyHgz({
            id: ids,
          })
          .then((res) => {
            this.loading = false;
            for (let index = 0; index < arrid.length; index++) {
              this.mainData = this.mainData.filter(
                (item) => item.Id != arrid[index]
              );
            }
            this.countData -= arrid.length;
          })
          .catch((error) => {
            this.loading = false;
            let message = (error && error.msg) || "删除选中选失败！";
            this.$store.commit("setsnack", { message });
            console.error(error);
          });
      } else {
        this.$store.commit("setsnack", {
          message: "尚未选择任何项目",
          color: "warning",
        });
      }
    },
    initialize() {
      let data = {
        limit: this.limit,
        offset: this.offset,
      };
      if (this.query != "") {
        data.query = this.query;
      }
      if (this.exclude != "") {
        data.exclude = this.exclude;
      }
      if (this.sortby != "") {
        data.sortby = this.sortby;
        data.order = this.order;
      }
      this.loading = true;
      this.$api
        .getMyHgzs(data)
        .then((res) => {
          this.loading = false;
          if (res.data) {
            this.mainData = res.data;
            this.countData = res.count;
          } else {
            this.mainData = [];
            this.countData = 0;
          }
        })
        .catch((error) => {
          this.loading = false;
          let message = (error && error.msg) || "获取数据列表失败！";
          this.$store.commit("setsnack", { message });
          console.error(error);
        });
      this.$api
        .getMyPiCis({
          limit: -1,
          fields: "Id,PiCi,Producter",
          sortby: "Id",
          order: "desc",
        })
        .then((res) => {
          if (res.data) {
            for (let index = 0; index < res.data.length; index++) {
              res.data[index].PiCi =
                res.data[index].Producter.Name + " " + res.data[index].PiCi;
            }
            this.lists1 = res.data;
          } else {
            this.$store.commit("setsnack", {
              message: "批次列表为空，请先建立批次！",
            });
            this.$router.push("/pici");
          }
        })
        .catch((error) => {
          let message = (error && error.msg) || "获取选择列表失败！";
          this.$store.commit("setsnack", { message });
          console.error(error);
        });
    },
    editItem(item) {
      this.editedIndex = this.mainData.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      const index = this.mainData.indexOf(item);
      if (confirm("确认删除此项数据吗?")) {
        const data = {
          id: item.Id,
        };
        this.loading = true;
        this.$api
          .delMyHgz(data)
          .then((res) => {
            this.loading = false;
            this.mainData.splice(index, 1);
            this.countData--;
          })
          .catch((error) => {
            this.loading = false;
            let message = (error && error.msg) || "删除失败！";
            this.$store.commit("setsnack", { message });
            console.error(error);
          });
      }
    },
    close() {
      this.dialog = false;
      this.dialog1 = false;
      this.$nextTick(() => {
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
        this.editedIndex = -1;
      });
    },
    active() {
      if (!this.$refs.form.validate()) return;
      this.editedItem.ProductNums = parseInt(this.editedItem.ProductNums);
      this.editedItem.StartCode = parseInt(this.editedItem.StartCode);
      this.editedItem.EndCode = parseInt(this.editedItem.EndCode);
      let data = JSON.parse(JSON.stringify(this.editedItem));
      delete data.PiCier.PiCi;
      delete data.PiCier.Producter;
      delete data.PiCier.Yangshi;

      delete data.CreateAt;
      delete data.UpdateAt;
      delete data.Status;
      this.editedItem.UpdateAt = this.$utils.formatDate(
        new Date(),
        "yyyy-MM-dd hh:mm:ss"
      );
      this.editedItem.PiCier = JSON.parse(
        JSON.stringify(
          this.lists1.filter((item) => item.Id == data.PiCier.Id)[0]
        )
      );
      this.editedItem.PiCier.PiCi = this.editedItem.PiCier.PiCi.split(" ")[1];
      data.Yangshi = 10;
      this.editedItem.PrintNums = data.EndCode - data.StartCode + 1;
      this.editedItem.Status = true;
      this.loading = true;
      this.$api
        .addMyHgz(data)
        .then((res) => {
          this.loading = false;
          this.editedItem.Id = res.data[0];
          this.editedItem.CreateAt = this.editedItem.UpdateAt;
          this.mainData.unshift(this.editedItem);
          this.countData++;
          this.close();
        })
        .catch((error) => {
          this.loading = false;
          let message = (error && error.msg) || "自助激活失败！";
          this.$store.commit("setsnack", { message });
          console.error(error);
        });
    },
    // 打印完成后的回调（接收子组件信号）
    onPrintFinished() {
      // console.log('打印完成后的回调（接收子组件信号）');
      this.loading = false;
      this.fixedCertificateList = [
        {
          id: 1,
          productName: "",
          spec: "",
          address: this.$store.state.userInfo.Usersproer.Addr,
          producer: this.$store.state.userInfo.Usersproer.Name,
          phone: this.$store.state.userInfo.Usersproer.Phone,
          date: "",
        },
      ];
      this.printWindowHandle.close();
    },
    save() {
      if (!this.$refs.form.validate()) return;
      // if (!/windows|win32/i.test(navigator.userAgent)) {
      //   this.$store.commit("setsnack", {
      //     message: "请在windows系统的计算机上执行打印",
      //   });
      //   return;
      // }
      this.editedItem.ProductNums = parseInt(this.editedItem.ProductNums);
      this.editedItem.PrintNums = parseInt(this.editedItem.PrintNums);
      let data = JSON.parse(JSON.stringify(this.editedItem));
      delete data.PiCier.PiCi;
      delete data.PiCier.Producter;
      delete data.PiCier.Yangshi;

      delete data.CreateAt;
      delete data.UpdateAt;
      delete data.Status;
      this.editedItem.UpdateAt = this.$utils.formatDate(
        new Date(),
        "yyyy-MM-dd hh:mm:ss"
      );
      this.editedItem.PiCier = JSON.parse(
        JSON.stringify(
          this.lists1.filter((item) => item.Id == data.PiCier.Id)[0]
        )
      );
      this.editedItem.PiCier.PiCi = this.editedItem.PiCier.PiCi.split(" ")[1];
      if (this.editedIndex > -1) {
        this.$store.commit("setsnack", {
          message: "不可对已打印出的合格证进行编辑！",
        });
      } else {
        // return
        this.loading = true;
        this.$api
          .addMyHgz(data)
          .then((res) => {
            if (!res.code || res.data.length < 2) {
              console.error("添加失败！");
              return;
            }
            this.editedItem.Id = res.data[0];
            this.editedItem.CreateAt = this.editedItem.UpdateAt;
            this.mainData.unshift(this.editedItem);
            this.countData++;
            // 初始化web打印组件数据并打印
            this.fixedCertificateList = [];
            for (let i = 1; i < res.data.length; i++) {
              this.fixedCertificateList.push({
                id: res.data[i].ewm,
                productName: this.editedItem.PiCier.Producter.Name,
                spec: this.editedItem.ProductNums + this.editedItem.ProductUnit,
                address: this.$store.state.userInfo.Usersproer.Addr,
                producer: this.$store.state.userInfo.Usersproer.Name,
                phone: this.$store.state.userInfo.Usersproer.Phone,
                date: this.editedItem.DateAt,
              });
            }
            this.$nextTick();
            setTimeout(() => {
              this.$refs.labelPrintRef.handlePrint(); //调用组件的打印功能
              this.printWindowHandle = this;
            }, 1000);
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            let message = (error && error.msg) || "添加失败！";
            this.$store.commit("setsnack", { message });
            console.error(error);
          });
      }
    },
  },
};
</script>
